import React from 'react';
import clsx from 'clsx';
import styles from './Checkbox.module.scss';

type Props = {
  type: string;
  name: string;
  value: string;
  label?: string;
  className?: string;
  bgImage: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  defaultChecked?: boolean;
  disabled?: boolean;
};

const Checkbox = React.forwardRef<HTMLInputElement, Props>((props, ref): JSX.Element => {
  const {
    type,
    name,
    value,
    label,
    className,
    bgImage,
    onChange,
    defaultChecked,
    disabled,
    ...other
  } = props;

  return (
    <div className={clsx(styles.container, className)}>
      <label className={styles.label}>
        <input
          ref={ref}
          type={type}
          name={name}
          value={value}
          className={styles.input}
          onChange={onChange}
          defaultChecked={defaultChecked}
          disabled={disabled}
          {...other}
        />
        <div className={styles.box} style={{
          backgroundImage: `url(${bgImage})`,
        }} />
      </label>
      {label && <p className={styles.text}>{label}</p>}
    </div>
  );
});

export default React.memo(Checkbox);